<template>
  <div class="NewsShow">
    <div style="width: 980px;margin: auto;">
      <div style="text-align: right;margin-top: 20px;">
        <el-button @click="openPass(2)">通过</el-button>
        <el-button @click="openRefuse(2)">不通过</el-button>
      </div>
      <div class="title-box" v-html="title"></div>
      <div class="date-box">发布时间：{{date}}</div>
      <div class="date-box">截止时间：{{endTime}}</div>
      <div v-html="content" class="details-box"></div>
    </div>
  </div>
</template>

<script>
import time from "@/core/time";
import {ElLoading} from "element-plus";
export default {
  created() {
  },
  mounted() {
    this.id = this.$route.query.id;
    this.filter();
  },
  data() {
    return {
      type:'',
      endTime:'',
      result:'',
      title:'',
      content:'',
      advice:'',
      userId:'',
      id:'',
      input:'',
      coverUrl:[],
      editor: ClassicEditor,
      editorData: '',
      totalNum: 0, pageNum: 1, pageSize: 6,
      news: [],
    }
  },
  methods:{

    filter(){
      // let data = {
      //   id:this.id,
      // };
      let data =this.id
      let loadingInstance = null;
      loadingInstance = ElLoading.service({ fullscreen: true});
      console.log(data)
      // //debugger
      this.$request.post('/ArAssess/selectAssess',data).then(data => {
        console.log(data);
        // this.name=data.obj.assess.name;
        this.title =  data.obj.assess.title;
        this.content = data.obj.assess.content;
         this.endTime= data.obj.assess.endTime
         //this.type= data.obj.assess.type
        this.date = time.formateDate(data.obj.assess.createdDate);
        this.endTime = time.formateDate(data.obj.assess.endTime);
        loadingInstance.close();
      })
    },
    openRefuse() {
      this.$prompt('请输入审核建议', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPattern: /\S/,
        inputErrorMessage: '内容不能为空',
      }).then(({value}) => {
        // console.log(value+'value**********');
        // //debugger
        let data = {
          advice: value,
          type: 4,
          id: this.id,
        }
        this.$request.post("/ArAssess/updateAdvice", data).then((data) => {
          console.log("上传成功!")
        })
        this.$message({
          type: 'success',
          message: '提交审核成功 '
        });
        this.$router.push({
          path: '/assessCheck',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      });
      // location.reload()

      // location.reload()
    },
    openPass() {
      this.$confirm('是否确认通过？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
          .then(() => {
            console.log(3);
            let data = {
              type:3,
              id:this.id,
            };
            this.$request.post('/ArAssess/checkAssess',data).then(data => {
              console.log("success!");
            })
            this.$message({
              type: 'success',
              message: '保存修改',

            });
            // location.reload()
            this.$router.push({
              path:'/assessCheck',
              // query:{
              //   id:value.id,
              // }
            })
          })
          .catch(action => {
            this.$message({
              type: 'info',
              message:'取消'
            })
          });

    },

  }
}
</script>

<style lang="less">
.ck-editor__editable {
  min-height: 500px;
  word-break:break-all;
}
.message-box{
  text-align: center;
  margin-top: 25px;
  font-size: 16px;
  line-height: 25px;
  .message-detail{
    display: inline-block;

  }
}
.NewsShow{
  width: 100%;
  height: 100%;
  a:link {color: black; text-decoration:none;} //未访问
  a:active {color: black; } //激活：红色
  a:visited {color:black;text-decoration:none;} //已访问
  a:hover {color: black; text-decoration:underline;} //鼠标移近
  .btn-back{
    border: none;
    font-size: 16px;
  }
  .title-box{
    text-align: center;
    font-size: 20px;
    margin: 60px 0 30px 0;
    font-weight: 800;
  }
  .date-box{
    font-size: 16px;
    color: #777777;
    text-align: center;
    padding-bottom: 48px;
  }
  .details-box{
    margin-top: 25px;
    font-size: 16px;
    line-height: 25px;
    text-align: left;
    img{
      align:center;
      max-width: 100%;
      max-height: 700px;
    }

  }
  .file-box{
    margin-top: 40px;
    padding-bottom: 50px;
  }
}
</style>
